module.exports = __webpack_public_path__ + "static/img/bg1.8360992.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/bg1.png
// module id = NvuV
// module chunks = 0